import dayjs from "dayjs";

export class LeagueFilter {
   startDateFrom?:Date;
   startDateTo?: Date;
   sportId?:number;
   countryId?:number;
   leagueStatus?:number;
   name?:string;

  public static leagueCalendarParams(): LeagueFilter {
    const startDate = dayjs().subtract(1, 'year').startOf('day');
    const endDate = dayjs().add(1, 'year').startOf('day');

    const leagueFilter = new LeagueFilter();
    leagueFilter.startDateFrom = startDate.toDate();
    leagueFilter.startDateTo = endDate.toDate();

    return leagueFilter;
  }
}
